var _defs, _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#979b9d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.94,23.26H3.06A2.63,2.63,0,0,1,.48,20.59V3.21A2.62,2.62,0,0,1,3.06.55H20.94a2.62,2.62,0,0,1,2.58,2.66V20.59A2.63,2.63,0,0,1,20.94,23.26ZM3.06,1.83a1.34,1.34,0,0,0-1.3,1.38V20.59A1.34,1.34,0,0,0,3.06,22H20.94a1.34,1.34,0,0,0,1.3-1.39V3.21a1.34,1.34,0,0,0-1.3-1.38Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.99,
    y: 7.63,
    width: 14.03,
    height: 2.01,
    rx: 1.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.99,
    y: 13.13,
    width: 14.36,
    height: 2.01,
    rx: 1.01
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/template_icon.19ed2cc6ce347738abb633c5a82ef91a.svg";
export { ForwardRef as ReactComponent };